import { useQuery } from "@apollo/client";
import { Suspense } from "react";
import { useIntl } from "react-intl";

import Suspender from "lib/Suspender";
import { WorkspaceFinancialsDoc } from "operations";

import { LoadingSkeleton } from "@joor/design-system";
import { totalUnits } from "./ProductCount";
import { StyledContent, StyledLabel, StyledTitle } from "./styledComponents";

const useSkuCount = (workspaceId: string, isBrand: boolean) => {
  const { data, loading } = useQuery(WorkspaceFinancialsDoc, {
    variables: { workspaceId },
  });

  const mappedUnits = data?.retailWorkspace?.assortments?.flatMap((a) =>
    a.financialOverview.financialDetails
      ?.filter((c) =>
        isBrand ? c.isBrandCurrency === true : c.isBrandCurrency === false
      )
      .map((c) => ({ currency: c.currencyCode, unit: c.units.skuCount }))
  );
  const skus = totalUnits(mappedUnits);

  return { loading, skus };
};

export const SkuCount = ({
  workspaceId,
  moreCurrencies,
  isBrand,
}: {
  workspaceId: string;
  moreCurrencies: boolean;
  isBrand: boolean;
}) => {
  const intl = useIntl();
  const { loading, skus } = useSkuCount(workspaceId, isBrand);

  const listSkusCount = skus?.map((count) => (
    <StyledTitle data-testid="sku-count-value">
      {intl.formatNumber(count) ?? 0}
    </StyledTitle>
  ));

  return (
    <StyledContent>
      <StyledLabel>SKUs</StyledLabel>
      <Suspense fallback={<LoadingSkeleton />}>
        <Suspender suspend={loading}>
          {moreCurrencies ? (
            listSkusCount
          ) : (
            <StyledTitle data-testid="sku-count-value">
              {skus[0] ? intl.formatNumber(skus[0]) : 0}
            </StyledTitle>
          )}
        </Suspender>
      </Suspense>
    </StyledContent>
  );
};
